var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.86,
    height: 17.86,
    viewBox: "0 0 17.86 17.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-help",
    d: "M11.93 3a8.93 8.93 0 1 0 8.93 8.93A8.933 8.933 0 0 0 11.93 3zm.893 15.181h-1.786V16.4h1.786zm1.849-6.921-.8.822a3.04 3.04 0 0 0-1.045 2.527h-1.79v-.447a3.594 3.594 0 0 1 1.045-2.527l1.107-1.125a1.746 1.746 0 0 0 .527-1.259 1.786 1.786 0 1 0-3.572 0H8.358a3.572 3.572 0 0 1 7.144 0 2.842 2.842 0 0 1-.83 2.009z",
    transform: "translate(-3 -3)",
    style: {
      fill: "#afafaf"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.5f24f35b.svg";
export { ForwardRef as ReactComponent };